import { EndpointBuilder } from '@reduxjs/toolkit/query/react';
import type { BaseQueryApi } from '@reduxjs/toolkit/query';
import {
    LoginRequest,
    LoginResponse,
    CompanyByEmail,
    RecoveryStartRequest,
    PasswordChangeRequest,
    PasswordChangeResponse,
} from './types';
import { ApiBaseQuery, ApiTagTypes } from '../types';

/**
 * Endpoints для аутентификации
 */
export const authEndpoints = (builder: EndpointBuilder<ApiBaseQuery, ApiTagTypes, 'api'>) => ({
    /**
     * Получение компаний по email
     */
    getCompaniesByEmail: builder.query<CompanyByEmail[], string>({
        query: (email) => ({
            url: '/public/customers_by_email',
            params: { email },
        }),
    }),
    /**
     * Логин пользователя
     */
    login: builder.mutation<LoginResponse, LoginRequest>({
        query: (credentials) => ({
            url: '/public/login',
            method: 'POST',
            params: { save_auth: credentials.save_auth },
            body: credentials,
        }),
        transformErrorResponse: (response: any) => {
            // Сохраняем оригинальный статус и данные для обработки ошибок
            return {
                status: response.status,
            };
        },
    }),
    /**
     * Выход пользователя
     */
    logout: builder.mutation<void, void>({
        query: () => ({
            url: '/private/logout',
            method: 'GET',
        }),
    }),
    /**
     * Запуск восстановления пароля
     */
    recoveryStart: builder.mutation<void, RecoveryStartRequest>({
        query: (body) => ({
            url: '/public/recovery/start',
            method: 'POST',
            body,
        }),
    }),
    passwordChange: builder.mutation<PasswordChangeResponse, PasswordChangeRequest>({
        query: (body) => ({
            url: '/public/recovery/password',
            method: 'POST',
            body,
        }),
    }),
});
